export function heroOverlapBackground() {
    const hero = document.querySelector('.hero .hero-inner--with-image');
    const page = document.querySelector('.page-content-container--over-hero');
    const cta = hero?.querySelector('.cta a');

    if (!hero || !page || !cta) return;

    const solidClass = 'page-content-container--over-hero--solid';

    // Create a sentinel at the top of the page content
    // Increase the negative value to trigger earlier (e.g., -100px)
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position: absolute; top: -160px; left: 0; width: 1px; height: 1px; pointer-events: none;';
    page.style.position = page.style.position || 'relative';
    page.insertBefore(sentinel, page.firstChild);

    // Calculate rootMargin based on CTA position
    const getRootMargin = () => {
        const ctaRect = cta.getBoundingClientRect();
        return `-${ctaRect.top}px 0px 0px 0px`;
    };

    let currentObserver = null;

    const init = () => {
        if (currentObserver) {
            currentObserver.disconnect();
        }

        const rootMargin = getRootMargin();

        currentObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    // When sentinel IS intersecting, page has reached the CTA
                    page.classList.toggle(solidClass, !entry.isIntersecting);
                });
            },
            {
                root: null,
                rootMargin: rootMargin,
                threshold: 0,
            }
        );

        currentObserver.observe(sentinel);
    };

    init();

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(init, 100);
    });
}
